document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".testimonial-swiper");
  if (!slider) return;

  const slidesCount = slider.querySelectorAll(".swiper-slide").length;

  new Swiper(slider, {
    loop: slidesCount > 2,   // 🔥 KEY FIX
    autoplay: slidesCount > 1 ? {
      delay: 4000,
      disableOnInteraction: false
    } : false,
    pagination: slidesCount > 1 ? {
      el: ".swiper-pagination",
      clickable: true
    } : false,
    navigation: slidesCount > 1 ? {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    } : false,
    slidesPerView: 1,
    spaceBetween: 30
  });
});
